const FooterBar = require('FooterBar');
const MenuController = require('MenuController');
const State = require('PSState');
const Events = require('PSEvents');
const Keyboard = require('PSKeyboardController');
const SpinButton = require('SpinButton');
const AutoplayButton = require('AutoplayButton');
const BetChanger = require('BetChanger');
const Header = require('HeaderInfo');
const PSPlatform = require('PSPlatform');
const SlotUI = require('./SlotUI');
const { UIComponentImplementationTypes, MenuElements, UIComponentModes } = require('./SlotUI');
const PSUIFeatures = require('../Modules/PSUIFeatures');
const PSUtils = require('PSUtils');

cc.Class({
    extends: cc.Component,

    properties: {
        footerBar: FooterBar,
        betChanger: BetChanger,
        menu: MenuController,
        spinButton: SpinButton,
        autoplayButton: AutoplayButton,
        header: Header,
        closeButton: cc.Button,
        menuButton: cc.Toggle,
        fastPlayToggle: cc.Toggle,
        mainButtonsContainer: cc.Node,
        gameNameLabel: cc.Label,
        menuTitle: cc.Label,
        sessionTimeContainer: cc.Node,
        timeContainer: cc.Node,
        funLabelContainer: cc.Node,
        blocker: cc.BlockInputEvents
    },

    onLoad () {
        this.widget = this.node.parent.getComponent(cc.Widget);
        this.blocker.enabled = false;
        this.funLabelContainer.active = false;

        this.gameNameLabel.string = '';


        Events.getLastAndSubscribe(Events.GAME_INNTER_CANVAS_SIZE_CHANGED, (data) => {

            this._updateTopMargin(data)
            // eslint-disable-next-line no-underscore-dangle
            cc._widgetManager.onResized();

        });
    },

    _updateTopMargin (data) {
        const top = PSUtils.convertToGameCanvasHeight(data.topValue);
        const target = this.node.parent;
        const wdt = target.getComponent(cc.Widget);
        wdt.top = top;
        wdt.bottom = 0;
        // wdt.updateAlignment();


        // // warning:: heavy computation
        // target.getComponentsInChildren(cc.Widget).forEach(item => item.updateAlignment());
    },

    onViewResized () {
        this._updateTopMargin(State.gameInnerCanvasSize);
    },

    updateKeyboardFeature (isChecked) {
        State.set({ keyboardFeature: isChecked });
        if (isChecked) {
            Keyboard.enable();
        } else {
            Keyboard.disable();
        }
    },

    openHistory () {
        this.menu.open('historyPage');
    },

    logoutClicked() {
        this.node.emit('logout');
    },

    closeButtonClicked() {
        this.node.emit('closeGame');
    },

    updateSounds (updateSoundState) {
        State.set(updateSoundState);
    },

    toggleFastPlay () {
        State.set({ quickSpinFeature: this.fastPlayToggle.isChecked });
    },

    start () {
        this.footerBar.node.on('footerBetButtonClicked', () => this.footerBetButtonClicked());
        this.menu.node.on('keyboardToggled',(isChecked) => this.updateKeyboardFeature(isChecked));
        this.menu.node.on('historyRequest',() => this.node.emit('historyRequest'));
        this.menu.node.on('closed',() => {
            this.node.emit('closed');

            this.blocker.enabled = false;
            this.spinButton.node.active = true;
            this.menuButton.isChecked = false;
        });
        this.menu.node.on('opened',(page) => {
            this.node.emit('opened', page);

            switch (page) {
                case 'bet':
                    this.betChanger.updateState(State);
            }
            this.blocker.enabled = true;
            this.spinButton.node.active = false;
            this.menuButton.isChecked = true;
        });

        this.autoplayButton.interactable = true;

        this.menu.active = true;
        this.mainButtonsContainer.active = false;
        this.menuEnabled = false;
        // this.hideStatusBar();
    },

    startReplay () {
        this.menuButton.interactable = false;
        this.menuButton.node.opacity = 100;
        State.menuEnabled = false;
    },

    stopReplay () {
        this.menuButton.interactable = true;
        this.menuButton.node.opacity = 255;
        this.menu._resume();
        State.menuEnabled = true;
    },

    footerBetButtonClicked () {
        if (!this.menu.isOpened('bet')) {
            this.menu.open('bet');
        } else {
            this.menu.close();
        }
    },

    onDiplsayClicked () {
        if (this.menu.isOpened()) {
            this.menu.backButtonClick();
        }
    },

    open (page, data) {
        this.menu.open(page, data);
    },

    close () {
        this.menu.close();
    },

    showAutoplay () {
        this.menu.autoplayButtonClick();
    },

    isCloseMenuDisabled () {
        return this.menu.page === 'infoPopup' || this.menu.page === 'realityCheck' || !this.menuButton.interactable;
    },

    menuButtonToggled () {
        if (this.isCloseMenuDisabled()) {
            this.menuButton.isChecked = true;
            return;
        }
        const { isChecked } = this.menuButton;

        if (isChecked && !this.menu.isOpened()) {
            this.menu.open();
        } else if (!isChecked && this.menu.isOpened()) {
            this.menu.close();
        }
    },

    escapeKey () {
        if (this.isCloseMenuDisabled()) {
            return;
        }

        if (this.menu.isOpened()) {
            this.menu.close();
        } else {
            this.menu.open();
        }
    },

    showWin (amount) {
        this.footerBar.showWin(amount);
    },

    accumulateWin (amount) {
        this.footerBar.accumulateWin(amount);
    },

    initConfig (configData) {
        const {
            gameName,
            gameDisplayName,
            minSpinDuration,
            sessionTime,
            autoplaySpinsLimit,
            autoplayLevels,
            language,
            gameBaseURL,
            funBanner,
            playMode,
            closeButton,
            provider
        } = configData;

        /**
         * BALANCE
         */
        const balanceConfig = SlotUI.getMenuElement(MenuElements.Balance);
        if (balanceConfig && !balanceConfig.enabled) {
            this.footerBar.hideBalance();
        }

        /**
         * FAST PLAY SKIP
         */
        const fastPlayConfig = SlotUI.getMenuElement(MenuElements.FastPlay);
        if (fastPlayConfig && !fastPlayConfig.enabled) {
            this.fastPlayToggle.node.active = false;
        }

        /**
         * MIN SPIN DURATION
         */
        if (minSpinDuration) {
            this.spinButton.enableTimer(minSpinDuration / 1000);
        }

        /**
         * AUTOPLAY CONFIGS
         */
        if(autoplayLevels) {
            State.availableNumberOfSpins = autoplayLevels;
        }

        if (autoplaySpinsLimit && autoplaySpinsLimit > 0) {
            const numSpins = State.availableNumberOfSpins.filter(i => i <= autoplaySpinsLimit);
            if (numSpins[numSpins.length - 1] !== autoplaySpinsLimit) {
                numSpins.push(autoplaySpinsLimit);
            }

            if (State.selectedSpinIndex >= numSpins.length) {
                State.selectedSpinIndex = 0;
            }

            State.availableNumberOfSpins = numSpins;
        }

        const autoplayConfig = SlotUI.getMenuElement(MenuElements.Autoplay);
        if (!autoplayConfig.enabled) {
            this.autoplayButton.hide();
        }
        this.menu.setAutoplay(autoplayConfig.mode === UIComponentModes.ADVANCED);
        this.autoplayController = this.menu.autoplayController;
        this.autoplayController.enableButtons();

        /**
         * Game Title
         */
        const gameTitleConfig = SlotUI.getMenuElement(MenuElements.GameTitle);
        const active = gameTitleConfig.enabled && gameTitleConfig.implementationType === UIComponentImplementationTypes.BUILTIN
        this.gameNameLabel.node.parent.active = active;
        this.gameNameLabel.string = gameDisplayName || gameName;
        this.menuTitle.string = gameDisplayName || gameName;

        const sessionTimeConfig = SlotUI.getMenuElement(MenuElements.SessionTime);
        this.sessionTimeContainer.active = Boolean(sessionTime) &&
            sessionTimeConfig.enabled &&
            sessionTimeConfig.implementationType === UIComponentImplementationTypes.BUILTIN;
        if (this.sessionTimeContainer.active) {
            this.sessionTimeContainer.getComponent('SessionTimeLabel').set(sessionTime);
        }

        /**
         * Clock
         */
        const clockConfig = SlotUI.getMenuElement(MenuElements.Clock);
        this.timeContainer.active = clockConfig.enabled &&
            clockConfig.implementationType === UIComponentImplementationTypes.BUILTIN;

        /**
         * Fun banner and close button
         */
        this.funLabelContainer.active = funBanner && playMode === 'FUN';
        const homeConfig = SlotUI.getMenuElement(MenuElements.Home);

        this.closeButton.node.active = closeButton && (PSPlatform.isMobile && homeConfig.enabled);

        /**
         * Menu button
         */
        if (SlotUI.isReplayMode()) {
            this.startReplay();
        }

        /**
         * Other
         */
        this.menu.initPaytable();
        this.menu.initGameRules(gameBaseURL, language);
        this.menu.initHistory();
    },

    initState (state) {
        this.betChanger.updateState(state);
        this.footerBar.updateState(state);
        this.footerBar.updateBalanceLabel(state.balance);

        this.menu.updateState(state);
    },

    updateState (state) {
        if (this.fastPlayToggle.isChecked !== state.quickSpinFeature) {
            this.fastPlayToggle.isChecked = state.quickSpinFeature;
        }
        this.footerBar.updateState(state);
        this.menu.updateState(state);
    },

    updateBalanceLabel (balance) {
        this.footerBar.updateBalanceLabel(balance);
    },

    showMaxLossPopup () {
        this.menu.open('infoPopup', {
            title: '',
            message: 'loss-limit-popup'
        });
    },

    showMaxWinPopup () {
        this.menu.open('infoPopup', {
            title: '',
            message: 'win-limit-popup'
        });
    },

    dialog () {},

    showStatusBar () {
        State.menuEnabled = this.menuButton.interactable;
        this.footerBar.node.active = true;
        this.mainButtonsContainer.active = true;
    },

    hideStatusBar () {
        State.menuEnabled = false;
        this.footerBar.node.active = false;
        this.mainButtonsContainer.active = false;
    },

    enable (arr) {
        State.enable(arr);
        for (let i = 0; i < arr.length; i++) {
            switch (arr[i]) {
                case PSUIFeatures.BET:
                    this.betChanger.enableBet();
                    break;
                case PSUIFeatures.AUTOPLAY:
                    this.autoplayController.enableButtons();
                    this.autoplayButton.enableButton();
                    break;
            }
        }
    },

    disable (arr) {
        State.disable(arr);
        for (let i = 0; i < arr.length; i++) {
            switch (arr[i]) {
                case PSUIFeatures.BET:
                    this.betChanger.disableBet();
                    break;
                case PSUIFeatures.AUTOPLAY:
                    this.autoplayButton.disableButton();
                    this.autoplayController.disableButtons();
                    break;
            }
        }
    }
});
